import {CustomerAutocomplete} from './customer-autocomplete'
import type {CustomerDataLayer} from './customer-data-layer'

type StepCustomerProps = {
    customerId: string | null
    error?: string
    dataLayer: CustomerDataLayer
    onChange: (customerId: string | null, customerName: string | null) => void
}

export function StepCustomer({customerId, error, dataLayer, onChange}: StepCustomerProps) {
    return (
        <CustomerAutocomplete
            value={customerId}
            error={error}
            dataLayer={dataLayer}
            onChange={onChange}
        />
    )
}
